import { Outlet, Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Navigation from '../components/customer/Navigation'
import Footer from '../components/customer/Footer'
import { LayoutDashboard, CreditCard, Receipt, MapPin } from 'lucide-react'

export default function DashboardLayout() {
  const { t } = useTranslation('portal')
  const location = useLocation()
  const base = '/dashboard'

  const links = [
    { to: base, label: t('dashboard.title'), icon: LayoutDashboard, end: true },
    { to: `${base}/payments`, label: t('dashboard.myPayments'), icon: Receipt, end: false },
    { to: `${base}/cards`, label: t('dashboard.myCards'), icon: CreditCard, end: false },
    { to: `${base}/addresses`, label: t('dashboard.myAddresses', 'My Addresses'), icon: MapPin, end: false },
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Navigation />
      <main className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <nav className="flex flex-wrap gap-2 mb-8 border-b border-slate-200 pb-4">
            {links.map(({ to, label, icon: Icon, end }) => {
              const isActive = end ? location.pathname === to : location.pathname.startsWith(to)
              return (
                <Link
                  key={to}
                  to={to}
                  className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-100'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {label}
                </Link>
              )
            })}
          </nav>
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  )
}
